module.exports = __webpack_public_path__ + "media/images/alf_wave-bcb6361f49a898726ce21d8b8ecdf4b6.svg";